export class JiveAddRefreshTokenModel{
    public code:string;
    public internalCompanyId:Number;
    public state:string;
}